import styled from "styled-components";
import { themeTypes } from "../../styled/Theme";

export const StyledStatusStamp = styled.div`
  font-family: ${(props) => props.theme.figma.base.fontfamily_mlstifo_headline};
  color: ${(props) =>
    props.theme.type === themeTypes.light
      ? props.theme.rgba.black_65
      : props.theme.figma.base.color_white_100};

  &.-dly,
  &.-post,
  &.-aban,
  &.-ppd,
  &.-delay,
  &.-canc {
    font-size: ${(props) => props.theme.mixins.pxToRem(10)};
    font-weight: ${(props) => props.theme.figma.base.fontweight_bold};
    border-radius: ${(props) => props.theme.mixins.pxToRem(20)};
    letter-spacing: 0.7px;
  }
`;

export const StyledStatusStampDot = styled.div`
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background-color: ${(props) => props.theme.figma.base.color_freshred_100};
`;
